import React from "react";
import { Row } from "reactstrap";

export default class DocView extends React.Component {
  constructor(props) {
    super(props);
    this.viewerRef = React.createRef();
    this.backend = new props.backend();
  }

  componentDidMount() {
    const { src } = this.props;
    const element = this.viewerRef.current;

    this.backend.init(src, element); // initializes the viewer within the div
  }

  render() {
    return (
      <Row>
        <div
          style={{
            marginBottom: "50px",
            paddingTop: "50px",
            width: "65%",
            height: "600px",
            marginLeft: "17.5%",
          }}
        >
          <div
            style={{ height: "100%", width: "100%" }}
            ref={this.viewerRef}
            id="viewer"
          ></div>
        </div>
      </Row>
    );
  }
}

/*
CUSTOM NAVIGATION

<div
    style={{
      marginTop: "5px",
      height: "650px",
      backgroundColor: "darkgray",
      width: "17%",
      marginLeft: "10%",
    }}
  >
    <h3 style={{ padding: "10px", margin: "10px" }}>
      {this.props.docName}
    </h3>
    <p onClick={this.scroll(1)}>Page 4</p>
  </div>


    scroll = (x) => {
    return () => {
      const { src } = this.props;
      const iframe = document.getElementById(this.props.src);
      iframe.src = `/pdfjs-2-3/web/viewer.html?file=${src}#page=${x}`;
    };
  };
  */
